module.exports = __webpack_public_path__ + "assets/img/25_318.21233e19.jpg";